// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f69bbbff","952":"31353ff2"}[chunkId] + ".chunk.js";
};